import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import {Link} from "react-router-dom";

class    ShowInsertMosavabat extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }


    componentDidMount() {

    }

    render() {
         

        return (
            <>
                <div className="box shadow-sm mb-3 rounded bg-white ads-box text-center overflow-hidden">
                    <img src="/images/ads1.png" className="img-fluid" alt="Responsive image" />
                        <div className="p-3 border-bottom">
                            <h6 className="font-weight-bold text-gold">
                                ثبت طرح جدید
                            </h6>
                            <p className="mb-0 text-muted">
                                ایده یا طرح یا پروژه خود را طرح نمائید
                            </p>
                        </div>
                        <div className="p-3">
                            <Link to="/membership/mosavabat/insert"  className="btn btn-outline-gold pl-4 pr-4">
                                ثبت
                            </Link>
                        </div>
                </div>

            </>
        ); 
  }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

ShowInsertMosavabat.contextType = MCbrowser;

export default ShowInsertMosavabat;
